export default __webpack_public_path__ + "static/media/search.dd3ac4af.svg";